import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ResponsePageable } from "app/model/cliente/pageable/responsePageable.model";
import { RelatorioModel } from "app/model/relatorio/relatorioModel";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class RelatorioService {
  apiURL = environment.API;

  httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth")),
  };

  constructor(private httpClient: HttpClient) {}

  getRelatoriosAll(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(
      this.apiURL + "/relatorio",
      this.httpOptions
    );
  }

  getRelatoriosPorCliente(idCliente: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/listar-relatorios-id-cliente/${idCliente}`,
      this.httpOptions
    );
  }

  getUsuariosPorCliente(idCliente: any) {
    return this.httpClient.get<any>(
      this.apiURL + `/usuarios/listar/${idCliente}`,
      this.httpOptions
    );
  }

  postRelatorio(
    relatorio: RelatorioModel,
    idCliente: number
  ): Observable<RelatorioModel> {
    return this.httpClient.post<any>(
      this.apiURL + "/salvar-relatorio/" + idCliente,
      relatorio,
      this.httpOptions
    );
  }

  deletarRelatorio(id: any) {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    return this.httpClient.get(this.apiURL + "/deletar-relatorio/" + id, {
      headers,
      responseType: "text",
    });
  }

  putRelatorio(
    relatorio: RelatorioModel,
    id: number
  ): Observable<RelatorioModel> {
    return this.httpClient.put<RelatorioModel>(
      this.apiURL + "/editar-relatorio/" + id,
      relatorio,
      this.httpOptions
    );
  }

  getUsersByRelatorioId(idRelatorio: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/listar-usuarios-id-relatorio/${idRelatorio}`,
      this.httpOptions
    );
  }

  getAssuntosRelatorio(): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/get-assuntos-relatorio`,
      this.httpOptions
    );
  }

  getAtributoAssuntosById(assuntoId: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/search-atributo-assuntos-by-id/${assuntoId}`,
      this.httpOptions
    );
  }

  executeQueryAssunto(idAssunto: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/execute-query-assunto/${idAssunto}`,
      this.httpOptions
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/relatorio.service.ts